var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-numeric-marker",class:{ '-active': _vm.active }},[(_vm.showLine)?_c('div',{staticClass:"-line"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"-number"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }